import type * as Basemaps from '@protomaps/basemaps'

export interface MapLibrary {
  maplibre: typeof import('maplibre-gl')
  basemaps: typeof Basemaps
}

let loading: Promise<MapLibrary> | null = null

/** MapLibre is large, so it is only loaded once a map scrolls into view, and only once per page. */
export function loadMapLibrary(): Promise<MapLibrary> {
  loading ??= (async () => {
    const [maplibre, { Protocol }, basemaps, { default: workerUrl }] = await Promise.all([
      import('maplibre-gl'),
      import('pmtiles'),
      import('@protomaps/basemaps'),
      import('maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'),
      import('maplibre-gl/dist/maplibre-gl.css'),
    ])
    maplibre.setWorkerUrl(workerUrl)
    maplibre.addProtocol('pmtiles', new Protocol().tile)

    return { maplibre, basemaps }
  })().catch((error: unknown) => {
    loading = null
    throw error
  })

  return loading
}
